<template>
  <div v-if="loading" class="loader">
    <b-spinner
      variant="primary"
      type="grow"
      :label="`${this.$t('reports.loadingLabel')}...`"
    ></b-spinner>
  </div>
  <div v-else>
    <div class="row header">
      <div class="col-12">
        <h4>Atendimento ao cliente</h4>
      </div>
    </div>

    <div v-if="this.myIh1 !== '0'" class="row">
      <div class="col-12">
        <span>Nacional:</span>
        <span class="idx-bold">
          {{ nationalData.customerService.score }}
        </span>
        <span>Regional - {{ groupData.name }}: </span>
        <span class="idx-bold">
          {{ groupData.customerService.score }}
        </span>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-4">
        <div class="chart-card">
          <h2>Índice consolidado</h2>
          <div class="chart-area">
            <radial-progress-bar
              :diameter="240"
              :stroke-width="20"
              innerStrokeColor="#f1f1f1"
              :startColor="customerService.color"
              :stopColor="customerService.color"
              :completed-steps="customerService.score"
              :total-steps="100"
            >
              <b
                :style="{
                  color: customerService.color,
                  fontSize: '2.8em',
                  fontWeight: 'bold',
                }"
                >{{ customerService.score }}</b
              >
            </radial-progress-bar>
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="chart-card">
          <h2>Índice por mês</h2>
          <div class="chart-area">
            <div class="col-12" style="max-width: 100%;">
              <highcharts :options="customerService.chartOptions"></highcharts>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <b-table
          :fields="fields"
          :items="customerService.items"
          caption-bottom
          sort-icon-left
        >
          <template v-slot:cell(question)="row">
            <div style="max-width: 85%;">
              {{ row.item.question }}
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <hr />

    <div class="row mt-5 header">
      <div class="col-12">
        <h4>Equipe de vendas</h4>
      </div>
    </div>

    <div v-if="this.myIh1 !== '0'" class="row">
      <div class="col-12">
        <span>Nacional:</span>
        <span class="idx-bold">
          {{ nationalData.salesTeam.score }}
        </span>
        <span>Regional - {{ groupData.name }}: </span>
        <span class="idx-bold">
          {{ groupData.salesTeam.score }}
        </span>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-4">
        <div class="chart-card">
          <h2>Índice consolidado</h2>
          <div class="chart-area">
            <radial-progress-bar
              :diameter="240"
              :stroke-width="20"
              innerStrokeColor="#f1f1f1"
              :startColor="salesTeam.color"
              :stopColor="salesTeam.color"
              :completed-steps="salesTeam.score"
              :total-steps="5"
            >
              <b
                :style="{
                  color: salesTeam.color,
                  fontSize: '2.8em',
                  fontWeight: 'bold',
                }"
                >{{ salesTeam.score }}</b
              >
            </radial-progress-bar>
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="chart-card">
          <h2>Índice por mês</h2>
          <div class="chart-area">
            <div class="col-12" style="max-width: 100%;">
              <highcharts :options="salesTeam.chartOptions"></highcharts>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <b-table
          :fields="fields"
          :items="salesTeam.items"
          caption-bottom
          sort-icon-left
        >
          <template v-slot:cell(question)="row">
            <div style="max-width: 85%;">
              {{ row.item.question }}
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress';
import { mapState } from 'vuex';
import api from '../../../../services/api';

export default {
  components: {
    RadialProgressBar,
  },

  data: () => ({
    userAuth: null,
    loading: true,
    fields: [
      {
        key: 'question',
        label: 'Pergunta',
        sortable: true,
      },
      {
        key: 'score',
        label: 'Score',
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'qty',
        label: 'Total',
        sortable: true,
        class: 'text-center',
      },
    ],
    customerService: {
      score: 0,
      items: [],
      color: '#4ce595',
      chartOptions: {
        title: {
          align: 'left',
          text: '',
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: 'column',
          borderColor: 'rgba(0, 0, 0, 0.09)',
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue"',
            fontSize: '12px',
            width: '100%',
            height: '350px',
          },
        },
        xAxis: {
          categories: [],
          visible: true,
          labels: {},
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          max: 100,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            fontWeight: 'bold',
          },
        },
        series: [
          {
            name: 'Score',
            data: [],
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
          line: {
            dataLabels: {
              enabled: true,
            },
          },
          area: {
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.05,
            borderWidth: 0,
          },
        },
        colors: ['#4ce595'],
      },
    },
    salesTeam: {
      score: 0,
      items: [],
      color: '#4ce595',
      chartOptions: {
        title: {
          align: 'left',
          text: '',
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: 'column',
          borderColor: 'rgba(0, 0, 0, 0.09)',
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue"',
            fontSize: '12px',
            width: '100%',
            height: '350px',
          },
        },
        xAxis: {
          categories: [],
          visible: true,
          labels: {},
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          max: 5,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            fontWeight: 'bold',
          },
        },
        series: [
          {
            name: 'Score',
            data: [],
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
          line: {
            dataLabels: {
              enabled: true,
            },
          },
          area: {
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.05,
            borderWidth: 0,
          },
        },
        colors: ['#4ce595'],
      },
    },
    nationalData: {
      customerService: {
        sum: 0,
        qty: 0,
        score: 0,
      },
      salesTeam: {
        sum: 0,
        qty: 0,
        score: 0,
      },
    },
    groupData: {
      name: null,
      customerService: {
        sum: 0,
        qty: 0,
        score: 0,
      },
      salesTeam: {
        sum: 0,
        qty: 0,
        score: 0,
      },
    },
  }),

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.getMercedesSalesInfo();
    },

    myActionId: function watchmyActionId() {
      this.getMercedesSalesInfo();
    },

    myActionsIds: function watchmyActionsIds() {
      this.getMercedesSalesInfo();
    },

    calendarDates: function watchCalendarDates() {
      this.getMercedesSalesInfo();
    },

    myIh1: function watchMyIh1() {
      this.getMercedesSalesInfo();
    },

    myHierarchies1: function watchMyHierarchies1(){
      this.getMercedesSalesInfo();
    },

    myIh2: function watchMyIh2() {
      this.getMercedesSalesInfo();
    },

    myHierarchies2: function watchMyHierarchies2(){
      this.getMercedesSalesInfo();
    },

    myMetric: function watchMyMetric() {
      this.getMercedesSalesInfo();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.getMercedesSalesInfo();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getMercedesSalesInfo();
    },
  },

  methods: {
    async getMercedesSalesInfo() {
      this.loading = true;

      const response = await api.get('/reports/marcedes/sales', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });

      const chartData = response.data.chartData;
      this.nationalData = response.data.chartDataNational;
      this.groupData = response.data.chartDataGroup;

      this.customerService.chartOptions.xAxis.categories = [];
      this.customerService.chartOptions.series[0].data = [];

      this.customerService.score = Number(chartData.customerService.score);

      chartData.customerService.months.forEach((el) => {
        this.customerService.chartOptions.xAxis.categories.push(el.month);
        this.customerService.chartOptions.series[0].data.push(Number(el.score));
      });

      this.customerService.items = chartData.customerService.questions;

      this.customerService.color = this.setColor(
        this.customerService.score,
        100,
      );

      this.salesTeam.chartOptions.xAxis.categories = [];
      this.salesTeam.chartOptions.series[0].data = [];

      this.salesTeam.score = Number(chartData.salesTeam.score);

      chartData.salesTeam.months.forEach((el) => {
        this.salesTeam.chartOptions.xAxis.categories.push(el.month);
        this.salesTeam.chartOptions.series[0].data.push(Number(el.score));
      });

      this.salesTeam.items = chartData.salesTeam.questions;

      this.salesTeam.color = this.setColor(this.salesTeam.score);

      this.loading = false;
    },

    setColor(score, limit) {
      if (limit === 100) {
        if (score >= 80) {
          return '#6bca6c';
        } else if (score < 80 && score >= 70) {
          return '#9fd77a';
        } else if (score < 70 && score >= 50) {
          return '#fbcf3f';
        } else if (score < 50 && score >= 20) {
          return '#fa834f';
        }
        return 'red';
      }

      if (score >= 4) {
        return '#6bca6c';
      } else if (score < 4 && score >= 3) {
        return '#9fd77a';
      } else if (score < 3 && score >= 2) {
        return '#fbcf3f';
      } else if (score < 2 && score >= 1) {
        return '#fa834f';
      }
      return 'red';
    },
  },

  async created() {
    this.loading = true;

    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getMercedesSalesInfo();
  },
};
</script>

<style lang="scss" scoped>
.loader {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #e1e1e1;
  padding: 16px;
  border-radius: 5px;
  height: 400px;

  h2 {
    font-size: 18px;
  }

  .chart-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/mercedes-sales/index.vue